import APIS from 'src/constants/ApiConfig';
import { BaseResult, IPageResult } from 'src/entity/BaseResult';
import { BookKeepingListItem, BookKeepingSearchParam, InstitutionListItem, InstitutionSearchParam} from 'src/entity/BookKeepingEntity';
import HttpService from 'src/services/HttpService';
import { message } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import { PromotOrderTypes } from 'src/entity/PromotionEntity';
import I18N from 'src/services/I18NService';


const bookKeepingApi = APIS.domainApi(APIS.bookKeepingAdmin.bookKeeping);
const institutionApi = APIS.domainApi(APIS.bookKeepingAdmin.institution);



/**
 * 记账机构管理service
 * @class BookKeepingService
 */
class BookKeepingService {
  
  /**
   * 初始化分页器配置
   */
  initPagination(current = 1, pageSize = 10,) {
    const result: PaginationProps = {
      total: 0,
      defaultCurrent: 1,
      current,
      defaultPageSize: pageSize,
      pageSize,
      pageSizeOptions: ['10', '20', '30', '40'],
      showSizeChanger: true,
    };
    return result;
  }

  /**
   * 根据条件查询配药中心关联的机构
   * @memberof BookKeepingService
   */
  fetchInstitutions = async (query: InstitutionSearchParam): Promise<InstitutionListItem[]> => {
    let result: InstitutionListItem[] = [];
    try {
      const res: BaseResult<InstitutionListItem[]> = await HttpService.get(institutionApi, query);
      if (res && res.success) {
        result = res.data;
      }
    } catch (error) {
      console.error('fetchBookKeepings faild: ', error);
      message.error('获取关联机构列表失败');
      throw error;
    }
    return result;
  };

  /**
   * 根据条件查询促销列表
   * @memberof BookKeepingService
   */
   fetchBookKeepings = async (query?: Partial<BookKeepingSearchParam>): Promise<IPageResult<BookKeepingListItem[]> | undefined> => {
    const param: Partial<BookKeepingSearchParam> =  query ? {...query} : {limit: 20, offset: 0};
    let result: IPageResult<BookKeepingListItem[]> | undefined;
    try {
      const res: BaseResult<IPageResult<BookKeepingListItem[]>> = await HttpService.get(bookKeepingApi, param);
      if (res && res.success) {
        result = res.data;
      }
    } catch (error) {
      console.error('fetchBookKeepings faild: ', error);
      message.error('获取记账机构列表失败');
      throw error;
    }
    return result;
  };

  /**
   * 添加记账机构
   */
  addBookKeepingInstitution = async (param: Partial<BookKeepingListItem>): Promise<boolean> => {
    let isSuccessed = false;
    try {
      const res: BaseResult<InstitutionListItem[]> = await HttpService.post(bookKeepingApi, param);
      if (res && res.success) {
        isSuccessed = true;
      } else if (!!res.msg) {
        message.error(res.msg);
      }
    } catch (error) {
      console.error('addInstitutions faild: ', error);
      message.error('新增机构失败');
    }
    return isSuccessed;
  }

  /**
   * 删除已关联的记账机构
   * @memberof BookKeepingService
   * @param uuid: 关联uuid
   */
   deleteBookKeepingInstitution = async (uuid: string): Promise<boolean> => {
    let isSuccessed = false;
    const api = `${bookKeepingApi}${uuid}/`;
    try {
      await HttpService.delete(api);
      isSuccessed = true;
      message.success('删除成功');
    } catch (error) {
      console.error('deleteBookKeepingInstitution: ', error);
      message.error('删除失败');
    }
    return isSuccessed;
  };
}

export default new BookKeepingService();



// WEBPACK FOOTER //
// ./src/services/BookKeepingService.ts